export default __webpack_public_path__ + "static/media/import_tags.194ebeb6.png";